import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as cartActions from '../../../actions/cartActions';
import * as dishes from '../../../constants/dishes';
import OrderModalStep from '../OrderModalStep/OrderModalStep';
import AmountSelector from '../../common/AmountSelector/AmountSelector';
import './AmountStep.less';

const DISH = dishes.BORSZCZ;
const MAX_COUNT = 9;

class AmountStep extends React.Component {
  constructor(props) {
    super(props);

    this.handleIncrease = this.handleIncrease.bind(this);
    this.handleDecrease = this.handleDecrease.bind(this);
  }

  handleIncrease() {
    const {cartActions} = this.props;
    cartActions.increaseCount(DISH, MAX_COUNT);
  }

  handleDecrease() {
    const {cartActions} = this.props;
    cartActions.decreaseCount(DISH, 1);
  }

  render () {
    const {handleIncrease, handleDecrease} = this;
    const {amount, onPrimaryAction, onClose} = this.props;

    return (
      <OrderModalStep className="amount-step"
        title="Wyberz ilość"
        primaryActionTitle="Dalej >>"
        onPrimaryAction={onPrimaryAction}
        onClose={onClose}>
          <AmountSelector value={amount} onIncrease={handleIncrease} onDecrease={handleDecrease}/>
          <aside className="product-showcase">
            <figure>
              <figcaption>Borszcz w słoiku 440ml</figcaption>
            </figure>
          </aside>
      </OrderModalStep>
    );
  }
}

AmountStep.propTypes = {
  amount: PropTypes.number.isRequired,
  cartActions: PropTypes.object.isRequired,
  onPrimaryAction: PropTypes.func,
  onClose: PropTypes.func
};

function mapStateToProps(state) {
  const cartItem = state.cart.cartItems
    .filter(item => item.dish.id === DISH.id)
    .pop();

  return {
    amount: cartItem ? cartItem.count : 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    cartActions: bindActionCreators(cartActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AmountStep);



// WEBPACK FOOTER //
// ./src/components/OrderModal/AmountStep/AmountStep.js